import Axios from '@/http'

export default {
  // 获取车牌检测详情
  getMotorRecogDetailApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('motorRecognition/detail', params).then((res) => {
        return resolve(res)
      })
    })
  }
}
